(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  function openPanel(id, source) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    opener = source || document.activeElement;
    dialog.showModal();
    if (id === 'cc-search') dialog.querySelector('input')?.focus();
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-open]');
    if (open) { openPanel(open.dataset.open, open); return; }
    const close = event.target.closest('[data-close]');
    if (close) { close.closest('dialog').close(); opener?.focus(); return; }
    const cart = event.target.closest('[data-cart-open]');
    if (cart) { event.preventDefault(); openPanel('cc-bag', cart); await refreshCart(); }
    if (event.target instanceof HTMLDialogElement) {
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) event.target.close();
    }
  });
  async function refreshCart() {
    try {
      const url = new URL(window.ccRoutes.cart, location.origin);
      url.searchParams.set('section_id','cc-cart-content');
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Cart unavailable');
      const html = await response.text();
      document.querySelector('[data-cart-content]').innerHTML = html;
      const res = await fetch(window.ccRoutes.cart + '.js');
      if(res.ok){const data=await res.json();document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=data.item_count;el.hidden=!data.item_count;});}
    } catch { document.querySelector('[data-cart-content]')?.querySelector('form')?.setAttribute('action',window.ccRoutes.cart); }
  }
  document.addEventListener('submit', async event => {
    const form=event.target;
    if(form.getAttribute('id')!=='cc-product-form') return;
    event.preventDefault();
    const button=form.querySelector('[data-add-to-cart]');
    const status=form.querySelector('[data-product-status]');
    button.disabled=true;status.textContent='';
    try {
      const response=await fetch(window.ccRoutes.add,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const data=await response.json();
      if(!response.ok) throw new Error(data.description||data.message||'Unable to add this item. Please try again.');
      await refreshCart();openPanel('cc-bag',button);
    } catch(error){status.textContent=error.message;}
    finally {button.disabled=form.querySelector('[data-variant-select]').selectedOptions[0].dataset.available!=='true';}
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-merch-colour],[data-merch-size]')){
      const wrap=event.target.closest('[data-merch-options]');
      const colour=wrap.querySelector('[data-merch-colour]');
      const colourIndex=colour.selectedIndex;
      const size=wrap.querySelector('[data-merch-size]').value;
      const master=document.querySelector('[data-merch-variant-select]');
      const option=[...master.options].find(item=>{
        const values=(item.dataset.options||'').split('|');
        return values.every((value,index)=>value===(index===colourIndex?size:'Large'));
      });
      if(option){master.value=option.value;master.dataset.merchMedia=colour.selectedOptions[0].dataset.media;master.dispatchEvent(new Event('change',{bubbles:true}));}
      return;
    }
    if(!event.target.matches('[data-variant-select]'))return;
    const option=event.target.selectedOptions[0];
    document.querySelector('[data-product-price]').textContent=option.dataset.price;
    const button=document.querySelector('[data-add-to-cart]');
    button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldOut:button.dataset.label;
    const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    const gallery=document.querySelector('[data-product-gallery]');
    const slides=gallery?[...gallery.querySelectorAll('[data-product-slide]')]:[];
    const mediaId=event.target.dataset.merchMedia||option.dataset.media;
    const media=mediaId?document.getElementById('media-'+mediaId.trim()):null;
    if(media){const rail=media.parentElement;rail.scrollLeft=media.offsetLeft;const index=slides.indexOf(media);const current=gallery?.querySelector('[data-gallery-current]');if(current&&index>=0)current.textContent=String(index+1);}
  });
  const initialSelector=document.querySelector('[data-merch-colour]')||document.querySelector('[data-variant-select]');
  initialSelector?.dispatchEvent(new Event('change',{bubbles:true}));
  const welcome=document.querySelector('[data-welcome-popup]');
  if(welcome){
    const successful=Boolean(welcome.querySelector('[data-welcome-success]'));
    const lastSeen=Number(localStorage.getItem('ccWelcomeSeen')||0);
    const shouldOpen=successful||Date.now()-lastSeen>14*24*60*60*1000;
    if(shouldOpen)setTimeout(()=>{if(!welcome.open){welcome.showModal();if(!successful)localStorage.setItem('ccWelcomeSeen',String(Date.now()));}},successful?150:2800);
  }
  function filterCatalog(input){
    const scope=input.closest('dialog')||document.querySelector('main');
    const words=input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);let count=0;
    scope.querySelectorAll('[data-search-title]').forEach(card=>{const show=words.every(word=>card.dataset.searchTitle.includes(word));card.hidden=!show;if(show)count++;});
    const empty=scope.querySelector('[data-search-empty]');if(empty)empty.hidden=count>0;
  }
  function enhanceInfoPages(root=document){
    root.querySelectorAll('[data-page-story]').forEach(story=>{
      if(story.dataset.enhanced)return;
      const handle=story.dataset.pageStory;
      const source=story.querySelector('.page-story-panel');
      if(!source)return;
      if(handle==='customer-service'){
        const groups=[];let group=null;
        [...source.children].forEach(node=>{
          if(node.matches('h3')&&node.textContent.trim()){
            group={title:node.textContent.trim(),nodes:[]};groups.push(group);
          }else if(group&&!node.matches('h4:empty')) group.nodes.push(node.cloneNode(true));
        });
        if(groups.length){
          story.replaceChildren();
          groups.forEach((item,index)=>{
            const panel=document.createElement('section');
            const isLast=index===groups.length-1&&groups.length%2===1;
            panel.className='page-story-panel rte '+(isLast?'page-panel-gradient page-panel-wide':index%2?'page-panel-black':'page-panel-white');
            const heading=document.createElement('h2');heading.textContent=item.title;panel.append(heading,...item.nodes);story.append(panel);
          });
          story.classList.add('is-enhanced');story.dataset.enhanced='true';
        }
        return;
      }
      if(!handle.includes('size-guide'))return;
      const tables=[...source.querySelectorAll('table')].map(table=>table.cloneNode(true));
      const paragraphs=[...source.querySelectorAll('p')].filter(p=>!p.closest('table')).map(p=>p.cloneNode(true)).filter(p=>p.textContent.trim());
      const excluded=/^(SIZE CONVERSION|PRODUCTS MEASUREMENTS|CLOTHING SIZE CHART|MEASURING GUIDE|Dresses|MiniDresses|T-Shirts|Leggings)$/i;
      const copy=paragraphs.filter(p=>!excluded.test(p.textContent.trim()));
      const images=[...source.querySelectorAll('img')].map(img=>img.cloneNode(true));
      story.replaceChildren();
      const copyPanel=document.createElement('section');copyPanel.className='page-story-panel rte page-panel-white size-guide-copy';
      copyPanel.innerHTML='<h2>How to measure</h2>';copyPanel.append(...copy);
      const guidePanel=document.createElement('section');guidePanel.className='page-story-panel rte page-panel-white size-guide-drawings';
      guidePanel.innerHTML='<h2>Measuring guide</h2>';
      const imageGrid=document.createElement('div');imageGrid.className='size-guide-images';imageGrid.append(...images);guidePanel.append(imageGrid);
      const tablePanel=document.createElement('section');tablePanel.className='page-story-panel rte page-panel-gradient page-panel-wide';
      tablePanel.innerHTML='<h2>Size charts</h2>';
      const tableGrid=document.createElement('div');tableGrid.className='size-table-grid';
      tables.forEach((table,index)=>{const block=document.createElement('div');block.className='size-table-block';const title=document.createElement('h3');title.textContent=tables.length>1&&index===0?'Size conversion':'Product measurements';block.append(title,table);tableGrid.append(block);});
      tablePanel.append(tableGrid);story.append(copyPanel,guidePanel,tablePanel);story.classList.add('is-enhanced');story.dataset.enhanced='true';
    });
  }
  function enhanceFeatureIcons(root=document){
    const icons={
      battery:'<svg viewBox="0 0 24 24"><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 2h6M8 15l3-5v4h5l-3 5"/></svg>',
      haptic:'<svg viewBox="0 0 24 24"><path d="M8 8c-2 2-2 6 0 8M5 5c-4 4-4 10 0 14M16 8c2 2 2 6 0 8M19 5c4 4 4 10 0 14"/><circle cx="12" cy="12" r="2"/></svg>',
      wireless:'<svg viewBox="0 0 24 24"><path d="M4 9a12 12 0 0 1 16 0M7 12a8 8 0 0 1 10 0M10 15a3 3 0 0 1 4 0"/><circle cx="12" cy="19" r="1"/></svg>',
      textile:'<svg viewBox="0 0 24 24"><path d="M4 7l8-4 8 4-8 4-8-4Zm0 5 8 4 8-4M4 17l8 4 8-4"/></svg>',
      stitch:'<svg viewBox="0 0 24 24"><path d="M4 7h16M4 17h16M7 7v3m4-3v3m4-3v3m4-3v3M7 14v3m4-3v3m4-3v3m4-3v3"/></svg>',
      leaf:'<svg viewBox="0 0 24 24"><path d="M20 4C10 4 4 9 4 16c0 3 2 4 4 4 7 0 12-6 12-16Z"/><path d="M6 18c3-4 6-7 11-10"/></svg>',
      person:'<svg viewBox="0 0 24 24"><circle cx="12" cy="7" r="3"/><path d="M5 21c0-5 3-8 7-8s7 3 7 8"/></svg>',
      check:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/></svg>',
      place:'<svg viewBox="0 0 24 24"><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2"/></svg>',
      box:'<svg viewBox="0 0 24 24"><path d="m4 7 8-4 8 4-8 4-8-4Z"/><path d="M4 7v10l8 4 8-4V7M12 11v10"/></svg>',
      sparkle:'<svg viewBox="0 0 24 24"><path d="M12 2c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10Z"/></svg>',
      chat:'<svg viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4V5Z"/><path d="M8 10h8M8 13h5"/></svg>',
      connection:'<svg viewBox="0 0 24 24"><path d="M9 15 7 17a4 4 0 0 1-6-6l3-3a4 4 0 0 1 6 0M15 9l2-2a4 4 0 0 1 6 6l-3 3a4 4 0 0 1-6 0M8 12h8"/></svg>'
    };
    root.querySelectorAll('.product-specifications>ul>li,.product-specifications>ol>li').forEach(item=>{
      if(item.querySelector('.feature-icon'))return;
      const text=item.textContent.toLowerCase();let type='sparkle';
      if(/recharge|battery|usb/.test(text))type='battery';
      else if(/haptic|hug|touch|music|game/.test(text))type='haptic';
      else if(/wireless|connectivity|bluetooth|app controlled/.test(text))type='wireless';
      else if(/textile|fabric|material|alcantara/.test(text))type='textile';
      else if(/hem|seam|construction|no wires/.test(text))type='stitch';
      else if(/sustain|zero.waste/.test(text))type='leaf';
      else if(/unisex|fit/.test(text))type='person';
      else if(/certif|rohs|fcc|oeko/.test(text))type='check';
      else if(/london|made in|venue|room/.test(text))type='place';
      else if(/packag|delivery/.test(text))type='box';
      else if(/direct line|team|contact/.test(text))type='chat';
      else if(/connection|people|person|explore/.test(text))type='connection';
      const icon=document.createElement('span');icon.className='feature-icon';icon.setAttribute('aria-hidden','true');icon.innerHTML=icons[type];item.prepend(icon);
    });
  }
  document.addEventListener('input',e=>{if(e.target.matches('[data-catalog-search]'))filterCatalog(e.target);});
  function initialize(root=document){
    enhanceInfoPages(root);
    enhanceFeatureIcons(root);
    root.querySelectorAll(".footer-explore").forEach(el=>{el.open=matchMedia("(min-width:900px)").matches;});
    root.querySelectorAll('[data-catalog-search]').forEach(filterCatalog);
    root.querySelectorAll('[data-rail]').forEach(rail=>{
      if(rail.dataset.ready)return;rail.dataset.ready='true';let start=0,scroll=0,active=false,moved=false;
      rail.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;start=e.clientX;scroll=rail.scrollLeft;active=true;moved=false;});
      rail.addEventListener('pointermove',e=>{if(!active)return;const delta=e.clientX-start;if(Math.abs(delta)>5){moved=true;rail.setPointerCapture(e.pointerId);rail.scrollLeft=scroll-delta;}});
      rail.addEventListener('pointerup',e=>{active=false;if(rail.hasPointerCapture(e.pointerId))rail.releasePointerCapture(e.pointerId);setTimeout(()=>moved=false,0);});
      rail.addEventListener('pointercancel',()=>{active=false;moved=false;});
      rail.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();}},true);
      rail.addEventListener('dragstart',e=>e.preventDefault());
    });
    root.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
      if(gallery.dataset.galleryReady)return;gallery.dataset.galleryReady='true';
      const rail=gallery.querySelector('[data-product-media]');const slides=[...gallery.querySelectorAll('[data-product-slide]')];const current=gallery.querySelector('[data-gallery-current]');
      if(!rail||slides.length<2)return;
      const update=()=>{const center=rail.scrollLeft+(rail.clientWidth/2);let closest=0;let distance=Infinity;slides.forEach((slide,index)=>{const next=Math.abs((slide.offsetLeft-rail.offsetLeft)+(slide.offsetWidth/2)-center);if(next<distance){distance=next;closest=index;}});if(current)current.textContent=closest+1;};
      let frame;rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth,behavior:'smooth'}));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth,behavior:'smooth'}));
      update();
    });
    root.querySelectorAll('[data-video-toggle]').forEach(button=>{
      if(button.dataset.videoReady)return;button.dataset.videoReady='true';
      const video=button.parentElement.querySelector('video');if(!video)return;
      const sync=()=>{const playing=!video.paused&&!video.ended;button.classList.toggle('is-playing',playing);button.setAttribute('aria-label',playing?button.dataset.pauseLabel:button.dataset.playLabel);};
      const toggle=()=>{if(video.paused)video.play();else video.pause();};
      button.addEventListener('click',toggle);video.addEventListener('click',toggle);
      video.addEventListener('play',sync);video.addEventListener('pause',sync);video.addEventListener('ended',sync);sync();
    });
  }
  initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-image-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeViewer(root=document) {
    const dialog=root.querySelector('[data-image-viewer]');
    if(!dialog||dialog.dataset.ready)return;
    dialog.dataset.ready='true';
    const section=dialog.closest('.shopify-section')||document;
    const sources=[...section.querySelectorAll('[data-image-open]')];
    const stage=dialog.querySelector('[data-zoom-stage]');
    const img=dialog.querySelector('[data-zoom-image]');
    const reset=dialog.querySelector('[data-zoom-reset]');
    const points=new Map();
    let index=0,scale=1,x=0,y=0,width=0,height=0,limit=4,opener,gesture=null,swipe=null;
    const clamp=(v,min,max)=>Math.max(min,Math.min(v,max));
    function draw(){
      x=clamp(x,-Math.max(0,(width*scale-stage.clientWidth)/2),Math.max(0,(width*scale-stage.clientWidth)/2));
      y=clamp(y,-Math.max(0,(height*scale-stage.clientHeight)/2),Math.max(0,(height*scale-stage.clientHeight)/2));
      img.style.transform=`translate(-50%,-50%) translate(${x}px,${y}px) scale(${scale})`;
      reset.textContent=Math.round(scale*100)+'%';
      dialog.querySelector('[data-zoom-out]').disabled=scale<=1;
      dialog.querySelector('[data-zoom-in]').disabled=scale>=limit;
    }
    function fit(){
      const source=sources[index];
      const nw=Number(source.dataset.imageWidth),nh=Number(source.dataset.imageHeight);
      const ratio=Math.min(stage.clientWidth/nw,stage.clientHeight/nh,1);
      width=nw*ratio;height=nh*ratio;limit=Math.max(2,Math.min(5,1/ratio));
      img.style.width=width+'px';img.style.height=height+'px';
      scale=1;x=y=0;draw();
    }
    function show(next){
      index=(next+sources.length)%sources.length;
      const source=sources[index];
      img.src=source.href;img.alt=source.querySelector('img').alt;
      dialog.querySelector('[data-zoom-count]').textContent=`${index+1} / ${sources.length}`;
      dialog.querySelector('[data-zoom-prev]').hidden=sources.length<2;
      dialog.querySelector('[data-zoom-next]').hidden=sources.length<2;
      fit();
    }
    function zoom(next,cx=0,cy=0){
      next=clamp(next,1,limit);const ratio=next/scale;
      x=cx-(cx-x)*ratio;y=cy-(cy-y)*ratio;scale=next;draw();
    }
    sources.forEach((source,i)=>source.addEventListener('click',e=>{
      if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
      e.preventDefault();opener=source;dialog.showModal();show(i);
    }));
    dialog.querySelector('[data-zoom-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{points.clear();gesture=swipe=null;opener?.focus({preventScroll:true});});
    dialog.querySelector('[data-zoom-prev]').addEventListener('click',()=>show(index-1));
    dialog.querySelector('[data-zoom-next]').addEventListener('click',()=>show(index+1));
    dialog.querySelector('[data-zoom-in]').addEventListener('click',()=>zoom(scale*1.5));
    dialog.querySelector('[data-zoom-out]').addEventListener('click',()=>zoom(scale/1.5));
    reset.addEventListener('click',()=>zoom(1));
    dialog.addEventListener('keydown',e=>{
      if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}
      if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}
      if(e.key==='+'||e.key==='='){e.preventDefault();zoom(scale*1.5);}
      if(e.key==='-'){e.preventDefault();zoom(scale/1.5);}
    });
    function position(e){const r=stage.getBoundingClientRect();return {x:e.clientX-r.left-r.width/2,y:e.clientY-r.top-r.height/2};}
    function begin(){
      const p=[...points.values()];
      gesture=p.length>=2?{distance:Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y),cx:(p[0].x+p[1].x)/2,cy:(p[0].y+p[1].y)/2,scale,x,y}:p.length?{px:p[0].x,py:p[0].y,x,y}:null;
    }
    stage.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      stage.setPointerCapture(e.pointerId);points.set(e.pointerId,position(e));
      swipe=points.size===1&&scale===1?{...position(e),time:Date.now()}:null;begin();
    });
    stage.addEventListener('pointermove',e=>{
      if(!points.has(e.pointerId))return;
      points.set(e.pointerId,position(e));const p=[...points.values()];
      if(p.length>=2&&gesture.distance){
        const next=clamp(gesture.scale*Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y)/gesture.distance,1,limit);
        const ratio=next/gesture.scale;
        x=(p[0].x+p[1].x)/2-(gesture.cx-gesture.x)*ratio;
        y=(p[0].y+p[1].y)/2-(gesture.cy-gesture.y)*ratio;scale=next;draw();
      }else if(p.length===1&&scale>1){x=gesture.x+p[0].x-gesture.px;y=gesture.y+p[0].y-gesture.py;draw();}
    });
    function end(e){
      if(!points.has(e.pointerId))return;
      const p=position(e),start=swipe;points.delete(e.pointerId);swipe=null;begin();
      if(e.type==='pointerup'&&start&&scale===1&&Date.now()-start.time<700&&Math.abs(p.x-start.x)>60&&Math.abs(p.x-start.x)>Math.abs(p.y-start.y)*1.5)show(index+(p.x<start.x?1:-1));
    }
    stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
    stage.addEventListener('dblclick',e=>{const p=position(e);zoom(scale>1?1:Math.min(2.5,limit),p.x,p.y);});
    stage.addEventListener('wheel',e=>{e.preventDefault();const p=position(e);zoom(scale*Math.exp(-e.deltaY*.002),p.x,p.y);},{passive:false});
    window.addEventListener('resize',()=>{if(dialog.open){points.clear();gesture=swipe=null;fit();}});
  }
  initializeViewer();document.addEventListener('shopify:section:load',e=>initializeViewer(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
